export const OrderStatuses = {
    APPROVED: 'approved',
    REJECTED: 'rejected',
    COMPLETED: 'completed',
    CANCELED: 'canceled',
    PAID: 'paid'
};
